<div class="register-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10">
        <div class="register-box">
          <div class="register-header text-center mb-4">
            <h2 class="mb-2">FORMULAR PENTRU ACCESAREA PORTALUI WEB</h2>
          </div>

          <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
            <!-- Nume pacient -->
            <div class="form-group mb-3">
              <label for="lastName" class="form-label">
                Nume pacient: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="lastName"
                class="form-control"
                formControlName="lastName"
                placeholder="Introduceți numele"
              />
              <div
                *ngIf="registerForm.get('lastName')?.invalid && registerForm.get('lastName')?.touched"
                class="text-danger small mt-1"
              >
                Numele este obligatoriu
              </div>
            </div>

            <!-- Prenume pacient -->
            <div class="form-group mb-3">
              <label for="firstName" class="form-label">
                Prenume pacient: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="firstName"
                class="form-control"
                formControlName="firstName"
                placeholder="Introduceți prenumele"
              />
              <div
                *ngIf="registerForm.get('firstName')?.invalid && registerForm.get('firstName')?.touched"
                class="text-danger small mt-1"
              >
                Prenumele este obligatoriu
              </div>
            </div>

            <!-- CNP -->
            <div class="form-group mb-3">
              <label for="cnp" class="form-label">
                CNP: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="cnp"
                class="form-control"
                formControlName="cnp"
                placeholder="Introduceți CNP-ul (13 cifre)"
                maxlength="13"
              />
              <div
                *ngIf="registerForm.get('cnp')?.invalid && registerForm.get('cnp')?.touched"
                class="text-danger small mt-1"
              >
                <span *ngIf="registerForm.get('cnp')?.errors?.required">CNP-ul este obligatoriu</span>
                <span *ngIf="registerForm.get('cnp')?.errors?.pattern">CNP-ul trebuie să conțină exact 13 cifre</span>
              </div>
            </div>

            <!-- Adresă -->
            <div class="form-group mb-3">
              <label for="address" class="form-label">
                Adresă: <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                id="address"
                class="form-control"
                formControlName="address"
                placeholder="Introduceți adresa completă"
              />
              <div
                *ngIf="registerForm.get('address')?.invalid && registerForm.get('address')?.touched"
                class="text-danger small mt-1"
              >
                Adresa este obligatorie
              </div>
            </div>

            <!-- Telefon -->
            <div class="form-group mb-3">
              <label for="phone" class="form-label">
                Telefon: <span class="text-danger">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                class="form-control"
                formControlName="phone"
                placeholder="Introduceți numărul de telefon"
              />
              <div
                *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched"
                class="text-danger small mt-1"
              >
                <span *ngIf="registerForm.get('phone')?.errors?.required">Telefonul este obligatoriu</span>
                <span *ngIf="registerForm.get('phone')?.errors?.pattern">Formatul telefonului nu este valid</span>
              </div>
            </div>

            <!-- Email -->
            <div class="form-group mb-3">
              <label for="email" class="form-label">
                Email: <span class="text-danger">*</span>
              </label>
              <input
                type="email"
                id="email"
                class="form-control"
                formControlName="email"
                placeholder="exemplu@email.com"
              />
              <div
                *ngIf="registerForm.get('email')?.invalid && registerForm.get('email')?.touched"
                class="text-danger small mt-1"
              >
                <span *ngIf="registerForm.get('email')?.errors?.required">Email-ul este obligatoriu</span>
                <span *ngIf="registerForm.get('email')?.errors?.email">Formatul email-ului nu este valid</span>
              </div>
            </div>

            <!-- Checkbox-uri GDPR -->
            <div class="gdpr-section mb-4">
              <!-- Checkbox 1 -->
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="hasAccount"
                  formControlName="hasAccount"
                />
                <label class="form-check-label" for="hasAccount">
                  Am deja cont în aplicația medicală
                </label>
              </div>

              <!-- Checkbox 2 -->
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="noAccountButAgree"
                  formControlName="noAccountButAgree"
                />
                <label class="form-check-label" for="noAccountButAgree">
                  Nu am cont dar sunt de acord cu crearea lui
                </label>
              </div>

              <!-- Checkbox 3 - GDPR Portal -->
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="gdprPortalConsent"
                  formControlName="gdprPortalConsent"
                />
                <label class="form-check-label" for="gdprPortalConsent">
                  Sunt de acord cu prelucrarea datelor personale conform GDPR,
                  atât la nivelul portalului cât și la nivelul aplicației
                  medicale <span class="text-danger">*</span>
                </label>
              </div>
              <div
                *ngIf="registerForm.get('gdprPortalConsent')?.invalid && registerForm.get('gdprPortalConsent')?.touched"
                class="text-danger small"
              >
                Acest câmp este obligatoriu
              </div>

              <!-- Checkbox 4 - CI Email -->
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="ciEmailConsent"
                  formControlName="ciEmailConsent"
                />
                <label class="form-check-label" for="ciEmailConsent">
                  Atașez la formular un CI valid și trimit documentele pe email
                  la portal@spitalcfpascani.ro
                  <span class="text-danger">*</span>
                </label>
              </div>
              <div
                *ngIf="registerForm.get('ciEmailConsent')?.invalid && registerForm.get('ciEmailConsent')?.touched"
                class="text-danger small"
              >
                Acest câmp este obligatoriu
              </div>

              <!-- Checkbox 5 - CI Secretariat -->
              <div class="form-check mb-3">
                <input
                  type="checkbox"
                  class="form-check-input"
                  id="ciSecretariatConsent"
                  formControlName="ciSecretariatConsent"
                />
                <label class="form-check-label" for="ciSecretariatConsent">
                  Atașez la formular un CI valid și depun documentele la
                  secretariatul spitalului <span class="text-danger">*</span>
                </label>
              </div>
              <div
                *ngIf="registerForm.get('ciSecretariatConsent')?.invalid && registerForm.get('ciSecretariatConsent')?.touched"
                class="text-danger small"
              >
                Acest câmp este obligatoriu
              </div>
            </div>

            <!-- Semnătura olografă -->
            <div class="form-group mb-4">
              <label for="signature" class="form-label">
                Semnătură olografă pacient:
              </label>
              <div class="signature-box">
                <input
                  type="text"
                  id="signature"
                  class="form-control"
                  formControlName="signature"
                  placeholder="___________________________________________"
                />
              </div>
            </div>

            <!-- Butoane -->
            <div class="form-actions text-center">
              <button
                type="submit"
                class="btn btn-primary btn-lg px-5"
                [disabled]="registerForm.invalid || submitting"
              >
                <span *ngIf="!submitting">Trimite cererea</span>
                <span *ngIf="submitting">
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Se trimite...
                </span>
              </button>

              <button
                type="button"
                class="btn btn-outline-secondary btn-lg px-5 ms-3"
                (click)="resetForm()"
                [disabled]="submitting"
              >
                Resetează
              </button>
            </div>

            <!-- Mesaje de succes/eroare -->
            <div *ngIf="successMessage" class="alert alert-success mt-4">
              {{ successMessage }}
            </div>
            <div *ngIf="errorMessage" class="alert alert-danger mt-4">
              {{ errorMessage }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
